import React, { useState, useEffect } from 'react';
import Button from '../ui/Button';
import { getTopic } from '@services/topicService'; // new import

const ConfirmCreateQuizModal = ({ show, onConfirm, onCancel, quiz_type, topic_id, expected_duration=null }) => {
  const [topicData, setTopicData] = useState(null);

  useEffect(() => {
    if (topic_id) {
      // fetch topic data using topic_id
      getTopic(topic_id)
        .then(data => {setTopicData(data); console.log(data)})
        .catch(err => console.error('Error fetching topic data:', err));
    } else {
      setTopicData(null);
    }
  }, [topic_id]);

  return (
    <div className={`modal ${show ? 'modal-open' : ''}`}>
      <div className="modal-box">
        <h3 className="font-bold text-lg">Confirm Create Quiz</h3>
        {topicData ? (
          <p className="mb-2 text-sm text-gray-700">
            Topic: {topicData.title}
          </p>
        ) : (
          <p className="mb-2 text-sm text-gray-700">
            Topic: {topic_id}
          </p>
        )}
        <p className="py-4">
          Are you sure you want to create this quiz  
          <b className='capitalize'> {quiz_type} quiz</b>  under <b>{topicData ? topicData.title : topic_id}</b>?
        </p>
        <div className="modal-action">
          <Button onClick={onConfirm}>Yes</Button>
          <button className="btn btn-ghost" onClick={onCancel}>Cancel</button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button onClick={onCancel}>close</button>
      </form>
    </div>
  );
};

export default ConfirmCreateQuizModal;
